var _defs, _circle, _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 187.2 187.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a8cf45;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #373435;\n      }\n\n      .cls-3 {\n        fill: #f5874f;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 93.64,
    cy: 93.63,
    r: 81.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 85.85,
    cy: 72.17,
    rx: 23.27,
    ry: 25.88
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m93.6,0C41.9,0,0,41.91,0,93.6s41.9,93.6,93.6,93.6,93.6-41.9,93.6-93.6S145.29,0,93.6,0Zm35.64,166.59c1.25-2.84,2.15-5.9,2.67-8.54.9-4.63,1.25-9.39.58-13.89-.83-5.45-3.19-10.49-7.93-14.41-4.13-3.4-9.34-5.31-14.63-6.05-5.87-.83-12.05-.49-17.83.79-24.85,5.49-31.87-.15-28.03-6.23,2.19-3.47,6.46-5.29,10.33-6.04,4.86-.94,9.97.44,14.9.06,4.17-.32,8.33-1.36,12.2-2.93,7.79-3.15,14.63-8.61,19.24-15.64.66-1,1.26-2.04,1.83-3.09,3.02-5.67,4.61-12.05,4.61-18.48,0-8.99-3.02-17.28-8.13-24l12.23-8.64-11.56-10.12-8.69,10.83c-3.5-2.63-7.44-4.72-11.7-6.15s-8.83-2.22-13.58-2.22c-22.87,0-41.42,18.04-41.42,40.3,0,15.71,9.24,29.32,22.72,35.96,0,0-17.68,4.83-17.68,17.19v.03c0,20.11,27.37,14.59,39.6,13.17,4.32-.51,8.69-.86,13.06-.63,3.59.18,7.5.42,10.39,2.84,2.6,2.18,3.76,5.71,3.82,9.1.1,6.02-1.81,12.31-5.77,17-4.25,5.03-10.55,7.34-16.95,8.02h1.29-1.18c-44.85,0-81.22-36.35-81.22-81.22S48.74,12.38,93.6,12.38s81.2,36.35,81.2,81.2c0,32.07-18.59,59.79-45.56,72.99h0ZM62.53,72.14c0-14.29,10.42-25.88,23.27-25.88s23.27,11.58,23.27,25.88-10.42,25.88-23.27,25.88-23.27-11.58-23.27-25.88h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGIcon);
export default __webpack_public_path__ + "static/media/G_Icon.d5c19c6865e9e426c2f8f85adc081b11.svg";
export { ForwardRef as ReactComponent };